import { render, staticRenderFns } from "./set-product-attr.vue?vue&type=template&id=3b744094&scoped=true&"
import script from "./set-product-attr.vue?vue&type=script&lang=js&"
export * from "./set-product-attr.vue?vue&type=script&lang=js&"
import style0 from "./set-product-attr.vue?vue&type=style&index=0&id=3b744094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b744094",
  null
  
)

export default component.exports